import React from 'react';
import HuubleCard from './HuubleCard';
import classes from '../styles/style.module.css';

const icons = [
    {
        icon: '/images/hubble/icons/eita.png',
        title: 'ایتا',
        link: 'https://eitaa.com/habel_event'
    },
    {
        icon: '/images/hubble/icons/insta.png',
        title: 'اینستاگرام',
        link: 'https://instagram.com/habel_event'
    },
    {
        icon: '/images/hubble/icons/eita.png',
        title: 'پشتیبانی',
        link: 'https://eitaa.com/habel_admin'
    },
    {
        icon: '/images/hubble/icons/rubica.png',
        title: 'تماس',
        link: "tel:03191690510"
    },
]

const HubbleContactMenu = () => {
    function handleClick(link) {
        window.open(link, "_blank");
    }

    return (
        <div className='my-5'>
            <HuubleCard>
                <div className={classes.contactMenu}>
                    <h5>
                        شبکه های اجتماعی
                    </h5>
                    <div className='mt-4'>
                        <div className='row justify-items-between'>
                            {icons.map((item, index) => {
                                return (
                                    <div key={index} className={`col-3 ${classes.socialMediaIconContainer}`} onClick={() => handleClick(item.link)}>
                                        <img style={{maxWidth:"24px"}} src={item.icon} alt='social media icon' />
                                        <p>{item.title}</p>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </HuubleCard>
        </div>
    )
}

export default HubbleContactMenu